export default __webpack_public_path__ + "static/media/menuly-dark-logo.e6963bfd.svg";